import { GET_REFERRING_DOCTORS } from '../../../custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';


const getReferringDoctors = createAsyncThunk('getReferringDoctors', async () => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = GET_REFERRING_DOCTORS
    let response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default getReferringDoctors;
